import React, { useEffect } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Box } from '@uhg-abyss/web/ui/Box';
import { setReportTypeVal } from '../../store/ReportTypeSlice';
import { FilesListTable } from './FilesListTable';
import { useDispatch } from 'react-redux';
export const Home = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setReportTypeVal('Welcome'));
  }, []);
  return (
    <>
      <Router.MetaTags title="Home" />
      <Box
        color="transparent"
        padding={0}
        css={{
          textAlign: 'center',
          margin: 0,
          '.abyss-data-table-subheader-lower-container': {
            display: 'flex',
            alignItems: 'flex-start',
          },
          '.abyss-data-table-pagination-top-root .abyss-data-table-pagination-top-sub-container, .abyss-data-table-pagination-top-root .abyss-pagination-results-root':
            {
              display: 'none',
            },
        }}
      >
        <FilesListTable />
      </Box>
    </>
  );
};
